import { translate } from '../../base/i18n/functions';
import { IconFaceRecognitionOn, IconFaceRecognitionOff } from '../../base/icons/svg/index';
import { connect } from '../../base/redux/functions';
import { AbstractButton } from '../../base/toolbox/components';
// @ts-ignore
import { setOverflowMenuVisible } from '../../toolbox/actions';
import { togglePictureInPicture } from '../actions';
import { isPictureInPictureEnabled, checkFilterSupport } from '../functions';
/**
 * Component that renders a toolbar button for toggling noise suppression.
 */
class PictureInPictureButton extends AbstractButton {
    constructor() {
        super(...arguments);
        this.accessibilityLabel = 'toolbar.accessibilityLabel.faceRecognition';
        this.icon = IconFaceRecognitionOn;
        this.label = 'toolbar.pictureInPicture';
        this.tooltip = 'toolbar.faceRecognition';
        this.toggledIcon = IconFaceRecognitionOff;
        this.toggledLabel = 'toolbar.pictureInPicture';
    }
    /**
     * Handles clicking / pressing the button.
     *
     * @private
     * @returns {void}
     */
    _handleClick() {
        const { dispatch } = this.props;
        dispatch(togglePictureInPicture());
        dispatch(setOverflowMenuVisible(false));
    }
    /**
     * Indicates whether this button is in toggled state or not.
     *
     * @override
     * @protected
     * @returns {boolean}
     */
    _isToggled() {
        return this.props._isPictureInPictureEnabled;
    }
}
/**
 * Maps part of the Redux state to the props of this component.
 *
 * @param {Object} state - The Redux state.
 * @private
 * @returns {Props}
 */
function _mapStateToProps(state) {
    return {
        _isPictureInPictureEnabled: isPictureInPictureEnabled(state),
        visible: checkFilterSupport()
    };
}
// @ts-ignore
export default translate(connect(_mapStateToProps)(PictureInPictureButton));
